import { HStack } from '@chakra-ui/react';
import { Link } from 'react-router';
import colors from 'src/theme/colors';
import fonts from 'src/theme/fonts';

function AdminNav() {
  return (
    <HStack>
      <Link to="/admin" style={adminLinkStyle}>
        Users
      </Link>
      <Link to="/admin/free-library" style={adminLinkStyle}>
        Free Library
      </Link>
      <Link to="/admin/jobs" style={adminLinkStyle}>
        Jobs
      </Link>
      <Link to="/admin/hosted-shows" style={adminLinkStyle}>
        Hosted Shows
      </Link>
      <Link to="/admin/hosting-limit-offenders" style={adminLinkStyle}>
        Hosting Limit Offenders
      </Link>
      <Link to="/admin/content" style={adminLinkStyle}>
        Content
      </Link>
    </HStack>
  );
}

export default AdminNav;

const adminLinkStyle = {
  color: colors.podcastShade400,
  fontFamily: fonts.bold,
  textDecoration: 'none',
  display: 'inline-block',
  padding: '15px 20px',
};
